export class MenuAvailabilityDto {
    all: number;
    active: number;
    inactive: number;
}